import axios from 'axios'
// import qs from 'qs'
// let url_initial = 'http://172.25.16.107:8000'


let url_initial = 'https://www.pgnice.com/'
// let url_initial = 'http://172.25.16.75:8000'


// 三大运营商总数
export const getVpdn = params => {
    return axios.get(`${url_initial}/ovpdnservcount/`,{params:params})
};

